import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/fitmatch.scss';

/**
 * Returns fit match graph with given percentage and optional explanation text supplied as children
 *
 * @example
 * <FitMatch
 *     classes={ {} }
 *     score={ '3' }
 * />;
 */
export default class FitMatch extends Component {
    render() {
        const { score, classes, children } = this.props;

        return <div className={ `${style.fitMatch} ${classes.root}` }>
            <div className={ `${style.figureWrapper} ${classes.figureWrapper}` }>
                <span>{ score ? `${score} %` : null }</span>
                <svg version="1.1" viewBox="0 0 80 160">
                    <g>
                        <circle r="80" cy="80" cx="80" className={ style.circles } />
                        <circle r="80" cy="80" cx="8" className={ style.circles } />
                        <defs>
                            <clipPath id="clipping-path">
                                <circle r="80" cy="80" cx="8" />
                            </clipPath>
                        </defs>
                        <circle r="80" cy="80" cx="80"
                            className={ style.overlap }
                            style={{ clipPath: "url('#clipping-path')" }} />
                    </g>
                </svg>
            </div>
            { children }
        </div>;
    }
}

FitMatch.propTypes = {
    score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    classes: PropTypes.shape({
        root: PropTypes.string,
        figureWrapper: PropTypes.string
    }),
    children: PropTypes.any
};

FitMatch.defaultProps = {
    score: null,
    classes: {
        root: '',
        figureWrapper: ''
    }
};
